// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__LCzQZ","container":"LoginPage_container__tYl7J","formContainer":"LoginPage_formContainer__NpVqf"};